// src/app/tokens.ts
import { InjectionToken } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';

export const ORIGINAL_DIALOG_SERVICE = new InjectionToken<DialogService>('OriginalDialogService');
